<div class="px-3 md:px-10 xl:px-[175px] w-full max-w-[1920px] mx-auto">

 <script type="application/ld+json">
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      "@id": "https://innovationplaza.it/cerca-bando/#webpage",
      "url": "https://innovationplaza.it/cerca-bando/",
      "name": "Bandi e Opportunita' di Finanziamento — Innovation Plaza",
      "description": "Bandi, call e programmi di finanziamento europei, nazionali e regionali per imprese, startup e istituzioni. Horizon Europe, FESR, FSE, MISE, PAC e programmi operativi regionali.",
      "inLanguage": "it-IT",
      "isPartOf": {
        "@id": "https://innovationplaza.it/#website"
      },
      "about": {
        "@type": "Thing",
        "name": "Finanziamenti e Bandi pubblici per l'innovazione"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://innovationplaza.it/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Bandi",
            "item": "https://innovationplaza.it/bandi/"
          }
        ]
      },
      "mainEntity": {
        "@type": "ItemList",
        "name": "Programmi di Finanziamento gestiti da Innovation Plaza",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Horizon Europe"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Digital Europe Programme"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Cooperazione Territoriale Europea (CTE)"
          },
          {
            "@type": "ListItem",
            "position": 4,
            "name": "Creative Europe"
          },
          {
            "@type": "ListItem",
            "position": 5,
            "name": "Bandi MISE per R&S"
          },
          {
            "@type": "ListItem",
            "position": 6,
            "name": "Programmi Operativi Regionali FESR-FSE-FC"
          },
          {
            "@type": "ListItem",
            "position": 7,
            "name": "Politica Agricola Comune (PAC)"
          }
        ]
      }
    },
    {
      "@type": "Service",
      "@id": "https://innovationplaza.it/cerca-bando/#service",
      "name": "Consulenza Strategica e Direzionale per l'Innovazione",
      "serviceType": "Consulenza di direzione e strategia",
      "description": "Supporto a imprese e istituzioni nei processi di analisi, strategia, marketing e ideazione. Gestione di iniziative complesse di sviluppo locale, territoriale e internazionale.",
      "url": "https://innovationplaza.it/cerca-bando/",
      "provider": {
        "@id": "https://innovationplaza.it/#organization"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Italia"
      },
      "audience": {
        "@type": "Audience",
        "audienceType": "Imprese, istituzioni, aspiranti imprenditori"
      }
    }
  ]
}
</script>

  <div class="absolute z-[-1] top-0 left-0 w-screen h-[614px]"
    style="background:radial-gradient(circle, #719CFF 0%, #283759 100%);"></div>

  <h1 class="text-222222 text-center text-font32px font-bold font-sans mt-10 mb-8">
    Bandi per l'Innovazione e la Ricerca Industriale 2025-2027
  </h1>

  <div class="w-full bg-white rounded-[20px] shadow-lg p-5 xl:p-10">

    <h2 class="font-medium text-font24px text-[#364349] mt-2 text-justify">
      Scopri bandi e incentivi per innovazione e ricerca: contributi PNRR, Horizon Europe e legge Patent Box
      per PMI
    </h2>

    <div (click)="goTo('cerca-bando')"
      class="mt-8 mb-8 text-white cursor-pointer bg-quintary ml-auto w-[226px] h-[47px] flex items-center place-content-center text-font24px font-bold rounded-full">
      Ricerca bandi
    </div>


    <h3 class="font-normal text-font18px text-[#364349] mt-4 ">
      <div class="r-and-s">

        <div class="text-[#364349] text-font24px text-justify">
          Il panorama degli incentivi pubblici per imprese, startup e Pubblica Amministrazione è ampio,
          stratificato e in continua evoluzione. Comprendere quali risorse sono disponibili, per chi, con quali
          scadenze è la premessa di qualsiasi strategia di accesso alla finanza agevolata. Innovation Plaza
          organizza questa complessità in 7 Macro-Aree Tematiche costruite sulla logica d'uso dell'imprenditore e
          del decisore pubblico — non sul linguaggio burocratico dei decreti ministeriali.
          Ogni area integra bandi europei diretti (Commissione UE), strumenti nazionali (MIMIT, Invitalia, MISE,
          INAIL) e misure regionali (PR FESR/FSE+), coprendo l'intero spettro di beneficiari: PMI, grandi imprese,
          startup innovative, enti pubblici, università e centri di ricerca.
        </div>

        <h4 class="font-semibold text-font24px text-[#364349] mt-8 mb-4">
          L'investimento in R&S come leva competitiva strutturale
        </h4>

        <div class="flex flex-col md:flex-row items-stretch gap-8 mt-6">
          <!-- Colonna Testo (Sinistra) -->
          <div class="md:w-2/3">
            <p class="mt-0 text-font24px line-height text-justify">
              Trasformare la conoscenza scientifica in vantaggio competitivo
              richiede accesso strategico alle risorse pubbliche per la ricerca e sviluppo.
              Il panorama degli incentivi per l'innovazione in Italia si articola su tre
              livelli integrati — europeo, nazionale e regionale — e copre
              l'intero spettro del ciclo di vita di un progetto R&S: dalla ricerca di base alla validazione
              industriale,
              dal deposito brevettuale alla commercializzazione dei risultati.
            </p>

            <p class="mt-4 text-font24px line-height text-justify">
              Innovation Plaza aggrega in questa <strong> bandi nazionali ed europei per imprese, università, centri
                di ricerca e consorzi pubblico-privati</strong> che operano in ambiti di ricerca industriale,
              sviluppo sperimentale e tutela della proprietà intellettuale.
            </p>
          </div>

          <!-- Colonna Immagine (Destra) -->
          <div class="md:w-1/3">
            <img src="assets/INNOVAZIONE_E_RICERCA_INDUSTRIALE.jpg" alt="Ricerca e Sviluppo"
              class="w-full max-h-[300px] object-cover rounded-[20px] shadow-lg">
          </div>
        </div>

        <h4 class="font-semibold text-font24px text-[#364349] mt-8 mb-4">
          Principali strumenti di finanziamento
        </h4>

        <div class="grid md:grid-cols-2 gap-6 mt-6">
          <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
            <h5 class="font-semibold text-[#364349] mb-3 leading-tight">Horizon Europe — Pillar II</h5>
            <p class="text-font24px text-gray-700 mb-2 text-justify">
              Il più grande programma di finanziamento europeo per la ricerca. Aperto a
              consorzi transnazionali composti da imprese, università ed
              enti di ricerca per sfide scientifiche ad alto impatto.
            </p>
          </div>

          <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
            <h5 class="font-semibold text-[#364349] mb-3 leading-tight">Accordi per l'Innovazione (MIMIT)</h5>
            <p class="text-font24px text-gray-700 mb-2 text-justify">
              Contratti di finanziamento per progetti complessi di ricerca industriale
              e sviluppo sperimentale in partenariato.
              Dotazioni cicliche nell'ordine dei 500 milioni di euro per apertura.</p>
          </div>
        </div>

        <div class="grid md:grid-cols-2 gap-6 mt-6">
          <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
            <h5 class="font-semibold text-[#364349] mb-3 leading-tight">Credito d'Imposta Ricerca & Sviluppo</h5>
            <p class="text-font24px text-gray-700 mb-2 text-justify">
              Agevolazione automatica applicabile alle spese R&S sostenute
              nell'esercizio. Strumento strutturale per le imprese con attività continuativa
              di ricerca, con aliquote differenziate per ricerca fundamental, industriale
              e sviluppo sperimentale.
            </p>
          </div>


          <div class="bg-gray-50 p-4 rounded-lg border border-gray-200">
            <h5 class="font-semibold text-[#364349] mb-3 leading-tight">Patent Box</h5>
            <p class="text-font24px text-gray-700 text-justify">
              Regime opzionale di tassazione agevolata sui redditi derivanti
              dall'utilizzo di beni immateriali (brevetti, software, know-how). Permette una
              maggiorazione fiscale del 110% dei costi di ricerca collegati all'IP.
            </p>
          </div>
        </div>

        <h4 class="font-semibold text-font24px text-[#364349] mt-12 mb-4">
          Dotazioni finanziarie di riferimento
        </h4>

        <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
          <div class="bg-amber-50 border-l-4 border-amber-500 p-4">
            <h5 class="font-semibold text-amber-800 text-sm">Horizon Europe (2021-2027)</h5>
            <p class="text-xs text-amber-700 mt-1" text-justify><strong>Oltre 95 miliardi di euro</strong> — il
              più grande programma R&S al mondo</p>
          </div>
          <div class="bg-orange-50 border-l-4 border-orange-500 p-4">
            <h5 class="font-semibold text-orange-800 text-sm">Accordi per l'Innovazione</h5>
            <p class="text-xs text-orange-700 mt-1" text-justify><strong>~500 milioni</strong> per ciclo operativo
              (rifinanziamenti MIMIT)</p>
          </div>
          <div class="bg-yellow-50 border-l-4 border-yellow-500 p-4">
            <h5 class="font-semibold text-yellow-800 text-sm">Credito d'Imposta R&S</h5>
            <p class="text-xs text-yellow-700 mt-1" text-justify><strong>Diversi miliardi di euro annui</strong>
              in risorse fiscali</p>
          </div>
          <div class="bg-slate-50 border-l-4 border-slate-500 p-4">
            <h5 class="font-semibold text-slate-800 text-sm">Patent Box</h5>
            <p class="text-xs text-slate-700 mt-1" text-justify>Agevolazione fiscale <strong>senza plafond di
                spesa</strong></p>
          </div>
        </div>

        <div
          class="mt-12 p-6 bg-gradient-to-r from-amber-50 via-orange-50 to-yellow-50 rounded-xl border-l-4 border-amber-500">
          <p class="text-font24px font-medium text-[#364349] mb-3 text-justify">
            <strong>Hai un progetto di ricerca industriale o sviluppo sperimentale?</strong>
          </p>
          <p class="text-font24px text-gray-700 text-justify">
            Cerca il bando più adatto al tuo profilo — filtra per tipologia di beneficiario, settore tecnologico e
            scadenza.
          </p>

          <div (click)="goTo('cerca-bando')"
            class="mt-8 text-white cursor-pointer bg-quintary ml-auto w-[226px] h-[47px] flex items-center place-content-center text-font24px font-bold rounded-full">
            Ricerca bandi
          </div>
        </div>

      </div>
    </h3>
  </div>
</div>